module.exports = __webpack_public_path__ + "static/media/0.1c54be97.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/rhand/0.png
// module id = 1438
// module chunks = 0